import { IApi, useClientApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useQueryClient } from '@tanstack/react-query'
import { useOrganizationId } from '@/features/organization/use-organization-id'
import type {
    RedeemVoucherBody,
    RedeemVoucherResponse,
} from 'api/dist/routes/organization/[organization_id]/credits/voucher'

export class RedeemVoucherMutation {
    static async call(api: IApi, organizationId: string, body: RedeemVoucherBody) {
        return api
            .post<RedeemVoucherResponse, RedeemVoucherBody>(`/organization/${organizationId}/credits/voucher`, body)
            .then((res) => res.data)
    }
}

export function useRedeemVoucherMutation() {
    const api = useClientApi()
    const qc = useQueryClient()
    const organizationId = useOrganizationId()

    return useApiMutation({
        mutationFn: (body: RedeemVoucherBody) => RedeemVoucherMutation.call(api, organizationId, body),
        onSuccess: async () => {
            await Promise.all([
                qc.invalidateQueries({ queryKey: ['organization', organizationId, 'billing-and-usage'] }),
                qc.invalidateQueries({ queryKey: ['organization', organizationId, 'credits', 'history'] }),
                qc.invalidateQueries({ queryKey: ['organization', organizationId, 'credits', 'usage'] }),
            ])
        },
    })
}
